'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colorIconStyle = exports.monoIconStyle = undefined;

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  box-sizing: content-box;\n  fill: currentColor;\n\n  [stroke] {\n    stroke: currentColor;\n  }\n\n  [fill] {\n    fill: currentColor;\n  }\n\n  [fill=\'none\'] {\n    fill: none;\n  }\n'], ['\n  box-sizing: content-box;\n  fill: currentColor;\n\n  [stroke] {\n    stroke: currentColor;\n  }\n\n  [fill] {\n    fill: currentColor;\n  }\n\n  [fill=\'none\'] {\n    fill: none;\n  }\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  box-sizing: content-box;\n  fill: currentColor;\n'], ['\n  box-sizing: content-box;\n  fill: currentColor;\n']);

var _emotion = require('emotion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var monoIconStyle = exports.monoIconStyle = (0, _emotion.css)(_templateObject);

var colorIconStyle = exports.colorIconStyle = (0, _emotion.css)(_templateObject2);